<template>
  <div>
    <h1 class="font-lg mb-2">Личный кабинет</h1>
    <v-tabs :value="currentTab" class="card-tabs mb-4" slider-size="3" optional>
      <v-tab v-for="tab in tabs" :key="tab.value" :tab-value="tab.value" @click="openTab(tab.value)">{{ tab.title }}</v-tab>
    </v-tabs>

    <OrdersTable v-if="currentTab === 'orders'" mode="my" />
    <CandidatesPage v-else-if="currentTab === 'candidates'" embedded />
    <ManagerCabinet v-else :userId="userId" @open-tab="openTab" />
  </div>
</template>

<script>
import ManagerCabinet from '@/components/managers/profile/ManagerCabinet.vue';
import OrdersTable from '@/components/orders/OrdersTable.vue';
import CandidatesPage from '@/views/candidates/Candidates.vue';

const TABS = [
  { value: 'overview', title: 'Обзор' },
  { value: 'candidates', title: 'Кандидаты', permission: 'bookmark_candidates' },
  { value: 'orders', title: 'Заказы' },
];

// Кабинет менеджера: те же вкладки, что у корпа. Остальные вкладки корпа (менеджеры, аналитика, операции)
// нужны сводка остатков компании, которую сервер менеджеру не отдаёт, поэтому здесь их нет.
export default {
  name: 'ManagerProfile',
  components: { ManagerCabinet, OrdersTable, CandidatesPage },
  props: {
    userId: { type: [Number, String], required: true },
  },
  computed: {
    // Вкладки по правам, как у корпа
    tabs() {
      return TABS.filter((t) => !t.permission || this.$store.getters['auth/isAllowed'](t.permission));
    },
    currentTab() {
      const { tab } = this.$route.query;
      return this.tabs.some((t) => t.value === tab) ? tab : 'overview';
    },
  },
  methods: {
    openTab(tab) {
      if (tab === this.currentTab) return;
      this.$router.push({ query: tab === 'overview' ? {} : { tab } });
    },
  },
};
</script>

<style scoped lang="scss">
// Вкладки как в кабинете корпа: обычный регистр, полужирные
.card-tabs {
  border-bottom: 1px solid #e0e0e0;
}

::v-deep .v-tab {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 600;
  font-size: 15px;
}
</style>
